import { HTMLAttributes } from 'react';

import clsx from 'clsx';

import { IconCheckCircleFill } from '../Icon';
import { Text } from '../Text';
import { badge, badgeIconWrapper, badgeTextColor } from './Badges.css';
import { BadgeSize, BadgeType } from './types';

export interface BadgesProps extends Omit<HTMLAttributes<HTMLDivElement>, 'prefix'> {
  /** 배지에 표시할 텍스트 */
  text?: string;
  /** 아이콘 표시 여부 (M 사이즈에만 적용) */
  showIcon?: boolean;
  /** 커스텀 아이콘 (기본: IconCheckCircleFill) */
  icon?: React.ReactNode;
  /** 배지 크기 */
  size?: BadgeSize;
  /** 배지 타입 */
  type?: BadgeType;
  /** 라이트 모드 여부 */
  light?: boolean;
}

export const Badges: React.FC<BadgesProps> = ({
  text = '1',
  showIcon = true,
  icon,
  size = 'm',
  type = 'border',
  light = false,
  className,
  ...props
}) => {
  const textStyle = size === 'm' ? '14_400' : '12_400';
  const shouldShowIcon = showIcon && size === 'm';

  return (
    <div
      className={clsx(
        badge({ size, type, light }),
        shouldShowIcon && badgeIconWrapper({ size }),
        className,
      )}
      {...props}
    >
      {shouldShowIcon && (
        <div style={{ width: '16px', height: '16px' }}>{icon || <IconCheckCircleFill />}</div>
      )}
      <Text textStyle={textStyle} className={badgeTextColor({ type, light })}>
        {text}
      </Text>
    </div>
  );
};
